import { apiSlice } from "../api/apiSlice";

export const assignmentApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getQuizs: builder.query({
            query: () => ({
                url: "/quizzes",
            }),
        }),
        getQuizByQuizIdAndVideoId: builder.query({
            query: ({ quizId, videoId }) => ({
                url: `/quizzes?id_like=${quizId}&video_id_like=${videoId}`,
            })
        }),
        getQuizByVideoId: builder.query({
            query: (videoId) => ({
                url: `/quizzes?video_id_like=${videoId}`,
            })
        }),
        addQuiz: builder.mutation({
            query: (data) => ({
                url: `/quizzes`,
                method: 'POST',
                body: data
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                // pessimistically cash update
                try {
                    const quiz = await queryFulfilled;
                    dispatch(apiSlice.util.updateQueryData("getQuizs", undefined, (draftQuizs) => {
                        draftQuizs.push(quiz.data)
                    }));

                } catch (error) {

                }
            }
        }),
        updateQuiz: builder.mutation({
            query: (data) => ({
                url: `/quizzes/${data.id}`,
                method: 'PATCH',
                body: data
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                // optimistic cash update
                const patchResult = dispatch(apiSlice.util.updateQueryData("getQuizs", undefined, (draftQuizs) => {
                    // const draftResult = draftQuizs.find(quiz => quiz.id == arg.id);

                    // draftResult.title = arg.title;
                    // draftResult.video_title = arg.video_title;
                    // draftResult.totalMark = arg.totalMark;
                }));

                try {
                    await queryFulfilled;

                } catch (error) {
                    patchResult.undo()
                }
            }
        }),
        deleteQuiz: builder.mutation({
            query: (quizId) => ({
                url: `/quizzes/${quizId}`,
                method: "DELETE",
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // optimistic cash update
                const patchResult = dispatch(apiSlice.util.updateQueryData("getQuizs", undefined, (draftQuizs) => {
                    const index = draftQuizs.findIndex(quiz => quiz.id == arg);
                    draftQuizs.splice(index, 1)
                }));

                try {
                    await queryFulfilled;
                } catch (error) {
                    patchResult.undo()
                }
            }
        }),
    }),
});

export const { useGetQuizsQuery, useGetQuizByQuizIdAndVideoIdQuery, useGetQuizByIdQuery, useGetQuizByVideoIdQuery, useAddQuizMutation, useUpdateQuizMutation, useDeleteQuizMutation } = assignmentApi;
